import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const DeleteLensModal = styled.div`
    width: 509px;
    padding: 24px;
`;

export const deleteButtonStyle = css`
    margin-left: 12px !important;
    background: ${Colors.Red.V150} !important;
`;

export const LensDeleteHeader = styled.span`
    padding-bottom: 12px;

    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    color: ${Colors.Black.V200};
`;

export const LensDeleteText = styled.p`
    padding-top: 12px;

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #16191c;
`;
